import { gql } from '@apollo/client';

import { StudentAssignmentsActivity } from '../../types';

export interface GetStudentAssignmentsByMonthQueryVariables {
  academyId: string;
  courseId: string;
  studentId: string;
  year: string;
  month: string;
}

export interface GetStudentAssignmentsByMonthQueryResult {
  assignments: StudentAssignmentsActivity[];
}

export const getStudentAssignmentsByMonthQuery = gql`
  query GetStudentAssignmentsByMonthQuery($academyId: String!, $courseId: String!, $studentId: String!, $year: String!, $month: String!) {
    assignments(academyId: $academyId, courseId: $courseId, studentId: $studentId, year: $year, month: $month)
      @rest(
        type: "StudentAssignmentsActivityByMonth"
        path: "/students-activity/academies/{args.academyId}/years/{args.year}/months/{args.month}/courses/{args.courseId}/students/{args.studentId}/assignments"
      ) {
      _id
      name
      answerId
      answerStartDate
      answerFinishDate
      score
    }
  }
`;
